var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[_c('span',{staticClass:"d-none d-xl-inline-block"},[_vm._v(_vm._s(_vm.$localDate(_vm.date)))]),_vm._v(" "),_c('span',{staticClass:"d-inline-block d-xl-none"},[_vm._v(_vm._s(_vm.$localDate(_vm.date, _vm.shortDateFormat)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }